import { Globe, ShieldX, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

const BlockedPreview = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5 flex items-center justify-center p-4">
      <div className="max-w-lg w-full">
        {/* Decorative background elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary/5 rounded-full blur-3xl" />
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-destructive/5 rounded-full blur-3xl" />
        </div>

        <div className="relative bg-card/50 backdrop-blur-sm border border-border/50 rounded-2xl p-8 md:p-12 shadow-2xl">
          {/* Icon */}
          <div className="flex justify-center mb-8">
            <div className="relative">
              <div className="w-24 h-24 rounded-full bg-gradient-to-br from-destructive/20 to-destructive/5 flex items-center justify-center">
                <ShieldX className="w-12 h-12 text-destructive" />
              </div>
              <div className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-muted flex items-center justify-center border-2 border-background">
                <Globe className="w-4 h-4 text-muted-foreground" />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="text-center space-y-4 mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground">
              Access Restricted
            </h1>
            <p className="text-lg text-muted-foreground leading-relaxed">
              We apologize, but our services are currently unavailable in your region due to regulatory requirements.
            </p>
          </div>

          {/* Info box */}
          <div className="bg-muted/50 rounded-xl p-4 mb-8">
            <p className="text-sm text-muted-foreground text-center">
              This restriction is in place to comply with local laws and regulations. We appreciate your understanding.
            </p>
          </div>

          {/* Contact section */}
          <div className="text-center space-y-4">
            <p className="text-sm text-muted-foreground">
              Think this is a mistake? We're here to help.
            </p>
            <Button variant="outline" className="gap-2" asChild>
              <a href="mailto:info@csw.live">
                <Mail className="w-4 h-4" />
                Contact Support
              </a>
            </Button>
          </div>

          {/* Preview badge */}
          <div className="absolute top-4 right-4">
            <span className="px-3 py-1 text-xs font-medium bg-primary/10 text-primary rounded-full">
              Preview Mode
            </span>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-muted-foreground mt-6">
          © {new Date().getFullYear()} CSW.live • All rights reserved
        </p>
      </div>
    </div>
  );
};

export default BlockedPreview;
